export default "__VITE_ASSET__55ec6519__"